import * as React from 'react';

export interface LazyListRowProps {
  readonly announceHeight: (id: number, height: number) => void;
  readonly offset: number;
  readonly id?: number;
}

export class LazyListRow extends React.PureComponent<LazyListRowProps> {
  private rowRef: React.RefObject<HTMLDivElement> = React.createRef();

  public render(): JSX.Element {
    return <div
      ref={this.rowRef}
      style={{ position: 'relative', top: this.props.offset }}>
      {this.props.children}
    </ div>;
  }

  public componentDidMount(): void {
    if (this.rowRef.current) { this.rowObserver.observe(this.rowRef.current, { childList: true, subtree: true }); }
    this.handleMutate();
  }

  public componentWillUnmount(): void {
    this.rowObserver.disconnect();
  }

  /**
   * Event handlers
   */
  private handleMutate = (): void => {
    this.props.announceHeight(this.props.id, this.rowRef.current!.getBoundingClientRect().height);
  }
  public rowObserver: MutationObserver = new MutationObserver(this.handleMutate);

}
